import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '秘密教学',
    url: 'https://mimijiaoxue.com',
    description: '解锁隐藏知识的高效学习法。揭示课堂之外、教科书背后的核心学习方法。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://mimijiaoxue.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '秘密教学',
    url: 'https://mimijiaoxue.com',
    description: '专注于揭示高效学习方法和隐藏知识传授体系的教育平台',
    sameAs: [
      'https://weibo.com/mimijiaoxue',
      'https://www.zhihu.com/org/mimijiaoxue',
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}